import { type FC } from 'react';

import { type IconProps } from './types';

export const SwapHorizontalV4Icon: FC<IconProps> = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.2929 2.29289C18.6834 1.90237 19.3166 1.90237 19.7071 2.29289L26.7071 9.29289C27.0976 9.68342 27.0976 10.3166 26.7071 10.7071L19.7071 17.7071C19.3166 18.0976 18.6834 18.0976 18.2929 17.7071C17.9024 17.3166 17.9024 16.6834 18.2929 16.2929L23.5858 11H6C5.44772 11 5 10.5523 5 10C5 9.44772 5.44772 9 6 9H23.5858L18.2929 3.70711C17.9024 3.31658 17.9024 2.68342 18.2929 2.29289ZM13.7071 14.2929C14.0976 14.6834 14.0976 15.3166 13.7071 15.7071L8.41421 21H26C26.5523 21 27 21.4477 27 22C27 22.5523 26.5523 23 26 23H8.41421L13.7071 28.2929C14.0976 28.6834 14.0976 29.3166 13.7071 29.7071C13.3166 30.0976 12.6834 30.0976 12.2929 29.7071L5.29289 22.7071C4.90237 22.3166 4.90237 21.6834 5.29289 21.2929L12.2929 14.2929C12.6834 13.9024 13.3166 13.9024 13.7071 14.2929Z"
        fill="#00FFBB"
      />
    </svg>
  );
};
